import React from 'react';
import OtkOptionCatalogList from '../../../components/otk/OtkOptionCatalogList';

/** qlty038 — REMOTE_NON_PROGRESSIVE via shared OtkOptionCatalogList (mask qlty038 / add qlty039 unchanged) */
export default function ProtocolTypeList() {
  return <OtkOptionCatalogList resource="protocol_types" />;
}
